import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center p-8 text-center">
      <h1 className="text-4xl font-bold mb-4">404 — Page Not Found</h1>
      <p className="text-lg mb-8 text-gray-600 dark:text-gray-400">
        That page doesn't exist. Let's get you back on track.
      </p>
      <div className="flex flex-wrap gap-4 justify-center">
        <Link
          to="/"
          className="inline-block px-6 py-3 rounded-md bg-gray-900 dark:bg-[#6cebe4] text-white dark:text-gray-900 font-semibold hover:opacity-90 transition"
        >
          ← Home
        </Link>
        <Link
          to="/portfolio"
          className="inline-block px-6 py-3 rounded-md border border-gray-400 dark:border-gray-600 text-gray-800 dark:text-gray-200 font-semibold hover:bg-gray-100 dark:hover:bg-gray-800 transition"
        >
          Portfolio
        </Link>
        <Link
          to="/store"
          className="inline-block px-6 py-3 rounded-md border border-gray-400 dark:border-gray-600 text-gray-800 dark:text-gray-200 font-semibold hover:bg-gray-100 dark:hover:bg-gray-800 transition"
        >
          Shop
        </Link>
      </div>
    </div>
  );
}
